import React from "react"
import { useDisclosure } from "@mantine/hooks"
import { Outlet } from "react-router-dom"
import styled from 'styled-components'

import { NavContext } from "src/components/navigation/NavContext"
import { AppShell, AppShellHeaderProps, Box, Burger, Group, Stack, createPolymorphicComponent, Flex, BoxProps } from "@mantine/core"
import { SideBarNavButton } from "src/components/ui/shell/SideBarNavButton"
import { DefaultTheme } from "src/theme/theme"
import { TopBarNavButton } from "src/components/ui/shell/TopBarNavButton"
import ProfileMenu from "src/components/ui/shell/ProfileMenu"
import { AnimatePresence } from "framer-motion"
import { BookwellLogo } from "src/components/ui/logos/BookwellLogo"
import { CourierToastComponent, NotificationsButton } from './shell/NotificationsButton'

const _StyledHeader = styled(AppShell.Header)`
    /* border-image-slice: 2; */
    border-bottom-width: 5px;
    border-color: var(--mantine-color-brand-5);
    /* border-image-source: linear-gradient(
        45deg, 
        var(--mantine-color-pink-5),
        var(--mantine-color-orange-5), 
        var(--mantine-color-yellow-5), 
        var(--mantine-color-green-5),
        var(--mantine-color-blue-5), 
        var(--mantine-color-violet-5)
    ); */
    /* [data-mantine-color-scheme='light'] & {
        background-color: var(--mantine-color-dark-8);
    }
    [data-mantine-color-scheme='dark'] & {
        background-color: var(--mantine-color-white);
    } */
    background-color: var(--mantine-color-white);
`
const StyledHeader = createPolymorphicComponent<'div', AppShellHeaderProps>(_StyledHeader)

const _NavGrid = styled(Box)`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    @media (max-width: ${DefaultTheme.breakpoints.md}) {
        grid-template-columns: 1fr auto auto;
    }
`
const NavGrid = createPolymorphicComponent<'div', BoxProps>(_NavGrid)

const HEADER_HEIGHT = 80

export const AppShellLayout = () => {

    const { menu } = React.useContext(NavContext)
    const [opened, { toggle }] = useDisclosure()

    return (
        <AppShell
            header={{ height: { base: 80, sm: HEADER_HEIGHT } }}
            navbar={{
                width: 300,
                breakpoint: 'md',
                collapsed: { desktop: true, mobile: !opened },
            }}
            padding="md"
            styles={{
                root: {
                    height: '100%'
                },
                main: {
                    padding: 0,
                    height: '100%',
                    minHeight: '100%',
                    maxHeight: '100%'
                }
            }}
        >
            <StyledHeader>

                <CourierToastComponent />

                <Box size="xl" h="100%" px="lg">

                    <Flex
                        h="100%"
                        direction="column"
                        justify="center"
                        align={{ base: 'flex-start', md: 'center' }}
                    >

                        <NavGrid>

                            <Group gap={5}>

                                <Burger
                                    opened={opened}
                                    onClick={toggle}
                                    hiddenFrom="md"
                                    size="sm"
                                    lineSize={3}
                                    color="gray.5"
                                />

                            <BookwellLogo height="50"/>

                            </Group>

                            <Box display="flex">

                                <Group gap="xs" visibleFrom="md">
                                    {menu.map((i, k) => {
                                        return <TopBarNavButton key={`nav-item-${k}`} to={i.to} label={i.label} icon={i.icon} onClick={toggle} />
                                    })}
                                </Group>

                            </Box>

                            <Group justify="flex-end" gap={2}>
                                <ProfileMenu />
                                <NotificationsButton />
                            </Group>

                        </NavGrid>

                    </Flex>

                </Box>

            </StyledHeader>

            <AppShell.Navbar p="md">

                <Stack gap="xs">
                    {menu.map((i, k) => {
                        return <SideBarNavButton key={`nav-item-${k}`} to={i.to} label={i.label} icon={i.icon} onClick={toggle} />
                    })}
                </Stack>

            </AppShell.Navbar>

            <AppShell.Main>

                    <Box
                        className="page-shell-wrapper"
                        style={{
                            height: '100%',
                            overflow: 'hidden'
                        }}
                        pt={{ base: 80, sm: 80 }}
                    >
                        <AnimatePresence mode="wait" initial={true} presenceAffectsLayout={false}>
                            <Outlet />
                        </AnimatePresence>

                    </Box>

            </AppShell.Main>
        </AppShell>
    )

}